/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Promotion_Submit_ActionInputs */

const en_directory_promotion_submit_action = /** @type {(inputs: Directory_Promotion_Submit_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit a sponsored tool`)
};

const zh_directory_promotion_submit_action = /** @type {(inputs: Directory_Promotion_Submit_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交赞助产品`)
};

/**
* | output |
* | --- |
* | "Submit a sponsored tool" |
*
* @param {Directory_Promotion_Submit_ActionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_promotion_submit_action = /** @type {((inputs?: Directory_Promotion_Submit_ActionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Promotion_Submit_ActionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_promotion_submit_action(inputs)
	return zh_directory_promotion_submit_action(inputs)
});
export { directory_promotion_submit_action as "directory.promotion.submit_action" }